import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { groupBy } from 'underscore';
import { setValue } from '@truqc/content-path';
import applyReducer, { reduceReducers } from './applyReducer';
import changeReducerFactory from './factories/changeReducerFactory';
import annotationSelectionConstants from '../constants/annotationSelectionConstants';
import reportDocumentConstants from '../constants/reportDocumentConstants';
import reportAnnotationConstants from '../constants/reportAnnotationConstants';
import issueConstants from '../constants/issueConstants';
import commonAnnotationTools from '../components/common/pdf/annotations/commonAnnotationTools';
const changeReducer = changeReducerFactory('reportAnnotation');
const initState = _objectSpread(_objectSpread({}, changeReducer.initState), {}, {
  issuesByPage: {},
  inksByPage: {},
  highlightsByPage: {},
  freeTextsByPage: {},
  infosByPage: {},
  linesByPage: {}
});
const annotationTypeByPage = function annotationTypeByPage(annotations, type) {
  let additionalFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const filtered = annotations.filter(item => {
    if (item[type] && item[type].id) {
      return additionalFactor ? item[type][additionalFactor.key] === additionalFactor.value : true;
    }
    return false;
  });
  return filtered ? groupBy(filtered, 'pageNumber') : {};
};
const sortAnnotationsByType = (state, _ref) => {
  let annotations = _ref.annotations;
  const lineFactor = {
    key: 'unsmoothed',
    value: 1
  };
  const inkFactor = {
    key: 'unsmoothed',
    value: 0
  };
  const issuesByPage = annotationTypeByPage(annotations, 'issue');
  const linesByPage = annotationTypeByPage(annotations, 'inkAnnotation', lineFactor);
  const inksByPage = annotationTypeByPage(annotations, 'inkAnnotation', inkFactor);
  const highlightsByPage = annotationTypeByPage(annotations, 'highlightAnnotation');
  const freeTextsByPage = annotationTypeByPage(annotations, 'freeTextAnnotation');
  const infosByPage = annotationTypeByPage(annotations, 'infoAnnotation');
  return _objectSpread(_objectSpread({}, state), {}, {
    issuesByPage,
    linesByPage,
    inksByPage,
    highlightsByPage,
    freeTextsByPage,
    infosByPage,
    list: annotations
  });
};

// make sure the new list and <annotationType>ByPage gets generated
const updateAnnotationList = state => {
  const newList = state.list.filter(ann => ann.id !== state.active.id);
  const action = {
    annotations: [...newList, state.active]
  };
  return sortAnnotationsByType(state, action);
};
const createInfo = (state, _ref2) => {
  let annotation = _ref2.annotation;
  const newAnnotations = [...state.list, annotation];
  const infosByPage = annotationTypeByPage(newAnnotations, 'infoAnnotation');
  return _objectSpread(_objectSpread({}, state), {}, {
    infosByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const createFreeText = (state, _ref3) => {
  let annotation = _ref3.annotation;
  const newAnnotations = [...state.list, annotation];
  const freeTextsByPage = annotationTypeByPage(newAnnotations, 'freeTextAnnotation');
  return _objectSpread(_objectSpread({}, state), {}, {
    freeTextsByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const createHighlight = (state, _ref4) => {
  let annotation = _ref4.annotation;
  const newAnnotations = [...state.list, annotation];
  const highlightsByPage = annotationTypeByPage(newAnnotations, 'highlightAnnotation');
  return _objectSpread(_objectSpread({}, state), {}, {
    highlightsByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const createLine = (state, _ref5) => {
  let annotation = _ref5.annotation;
  const newAnnotations = [...state.list, annotation];
  const lineFactor = {
    key: 'unsmoothed',
    value: 1
  };
  const linesByPage = annotationTypeByPage(newAnnotations, 'inkAnnotation', lineFactor);
  return _objectSpread(_objectSpread({}, state), {}, {
    linesByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const createInk = (state, _ref6) => {
  let annotation = _ref6.annotation;
  const newAnnotations = [...state.list, annotation];
  const inkFactor = {
    key: 'unsmoothed',
    value: 0
  };
  const inksByPage = annotationTypeByPage(newAnnotations, 'inkAnnotation', inkFactor);
  return _objectSpread(_objectSpread({}, state), {}, {
    inksByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const createIssue = (state, _ref7) => {
  let annotation = _ref7.annotation;
  const newAnnotations = [...state.list, annotation];
  const issuesByPage = annotationTypeByPage(newAnnotations, 'issue');
  return _objectSpread(_objectSpread({}, state), {}, {
    issuesByPage,
    list: newAnnotations,
    active: annotation,
    pendingChanges: true
  });
};
const select = (state, action) => {
  if (action.annotationContext === 'report') {
    return _objectSpread(_objectSpread({}, state), {}, {
      active: action.payload,
      originalActive: action.payload
    });
  }
  return state;
};
const deleteSuccess = (state, _ref8) => {
  let reportAnnotationID = _ref8.data.reportAnnotationID;
  const list = state.list;
  let annotationIndex = 0;
  list.forEach((next, index) => {
    if (next.id === reportAnnotationID) {
      annotationIndex = index;
    }
  });
  const newList = JSON.parse(JSON.stringify(list));
  newList.splice(annotationIndex, 1);
  return _objectSpread(_objectSpread(_objectSpread({}, state), sortAnnotationsByType({}, {
    annotations: newList
  })), {}, {
    // re-sort the whole list
    active: {},
    originalActive: {},
    pendingChanges: false
  });
};
const deleteFailure = (state, _ref9) => {
  let reportAnnotationID = _ref9.data.reportAnnotationID;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: "Failed to delete report annotation with this ID: ".concat(reportAnnotationID)
  });
};
const clearSelection = (state, action) => {
  if (action.annotationContext === 'report') {
    return _objectSpread(_objectSpread({}, state), {}, {
      active: {}
    });
  }
  return state;
};

// filter thru our annotations and return the one that matches the type id
const selectByAnnotationTypeID = (state, _ref0) => {
  let annotationTypeID = _ref0.data.annotationTypeID;
  const annotation = state.list.find(next => next.issue && next.issue.id === annotationTypeID || next.inkAnnotation && next.inkAnnotation.id === annotationTypeID || next.highlightAnnotation && next.highlightAnnotation.id === annotationTypeID || next.freeTextAnnotation && next.freeTextAnnotation.id === annotationTypeID || next.infoAnnotation && next.infoAnnotation.id === annotationTypeID);
  return _objectSpread(_objectSpread({}, state), {}, {
    active: annotation || {},
    originalActive: annotation || {}
  });
};
const reset = () => initState;

/**
 * keep reportAnnotation.active data up-to-date with issue.active changes
 * only need to handle `color` and `label`, since this data is required for PDF rendering
 */
const changeIssue = (state, _ref1) => {
  let content = _ref1.changeEvent.content;
  if (content === undefined) {
    return state;
  }
  const active = state.active;
  if (active.issue === undefined || active.issue.content === undefined) {
    return state;
  }
  const color = content.color,
    label = content.label;
  if (label !== undefined || color !== undefined) {
    let newContent = typeof active.issue.content === 'string' ? JSON.parse(active.issue.content) : JSON.parse(JSON.stringify(active.issue.content));

    // then use the adjusted path to ramda.set the value in newContent
    if (color !== undefined) {
      newContent = setValue('color', newContent, color);
    }
    if (label !== undefined) {
      newContent = setValue('label', newContent, label);
    }
    const newState = changeReducer.reducers[reportAnnotationConstants.CHANGE](state, {
      id: state.active.id,
      data: JSON.stringify(newContent),
      path: 'issue/content'
    });
    let finalState = newState;

    // we want to go ahead and set the color properly on the report annotation, that gets saved too
    if (color !== undefined) {
      finalState = changeReducer.reducers[reportAnnotationConstants.CHANGE](newState, {
        id: state.active.id,
        data: commonAnnotationTools.toRGBAString(color),
        path: 'colorString'
      });
    }
    return updateAnnotationList(finalState);
  }
  return state;
};
const saveFail = (state, _ref10) => {
  let error = _ref10.error,
    data = _ref10.data;
  if (error.response.status !== 410) {
    return changeReducer.reducers[reportAnnotationConstants.SAVE_FAIL](state, {
      error,
      data
    });
  }
  const id = data.id;
  const modifiedList = state.list.filter(annotation => annotation.id !== id);
  const action = {
    annotations: [...modifiedList]
  };
  const annotationState = sortAnnotationsByType(state, action);
  return _objectSpread(_objectSpread(_objectSpread({}, state), annotationState), {}, {
    active: {},
    pendingChanges: false,
    loading: false
  });
};
const reducers = _objectSpread(_objectSpread({}, changeReducer.reducers), {}, {
  [reportAnnotationConstants.CREATE_INFO]: createInfo,
  [reportAnnotationConstants.CREATE_FREETEXT]: createFreeText,
  [reportAnnotationConstants.CREATE_HIGHLIGHT]: createHighlight,
  [reportAnnotationConstants.CREATE_INK]: createInk,
  [reportAnnotationConstants.CREATE_LINE]: createLine,
  [reportAnnotationConstants.CREATE_ISSUE]: reduceReducers(changeReducer.reducers[reportAnnotationConstants.CREATE], createIssue),
  [reportAnnotationConstants.CHANGE]: reduceReducers(changeReducer.reducers[reportAnnotationConstants.CHANGE], updateAnnotationList),
  [reportAnnotationConstants.UNDO_CHANGES]: reduceReducers(changeReducer.reducers[reportAnnotationConstants.UNDO_CHANGES], updateAnnotationList),
  [reportAnnotationConstants.SAVE_FAIL]: saveFail,
  [reportAnnotationConstants.SELECT_BY_TYPE_ID]: selectByAnnotationTypeID,
  [reportAnnotationConstants.RESET]: reset,
  [reportAnnotationConstants.DELETE_SUCCESS]: deleteSuccess,
  [reportAnnotationConstants.DELETE_FAILURE]: deleteFailure,
  [reportDocumentConstants.RENDER_SUCCESS]: sortAnnotationsByType,
  [issueConstants.CHANGE_CONTENT]: changeIssue,
  [annotationSelectionConstants.SELECT]: select,
  [annotationSelectionConstants.CLEAR_SELECTION]: clearSelection
});
export default applyReducer(reducers, initState);